// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"1a251edb","298":"d1b14323","462":"a531560f","621":"0a3093b5","841":"648ab0e2","965":"d1b14323"}[chunkId] + ".chunk.css";
};